define(
    [
        'jquery',
        'underscore',
        'assets/js/backbone-extended',
        'assets/js/modules/design/designProductContext',
        'assets/js/modules/design/designOptionsContext',
        'assets/js/modules/design/designFacesCollection'
    ],
    function($, _, backboneExtended, designProductContext, designOptionsContext, designFacesCollection) {
        var ORIENTATION_HORIZONTAL = 'horizontal';
        var ORIENTATION_VERTICAL = 'vertical';

        return backboneExtended.NestedModel.extend(
            {
                relations: {
                    productContext: designProductContext,
                    faces: designFacesCollection,
                    optionsContext: designOptionsContext
                },
                defaults: {
                    pgId: null,
                    designerType: null,
                    orientation: ORIENTATION_HORIZONTAL,
                    width: null,
                    height: null
                }
            },
            {
                ORIENTATION_HORIZONTAL: ORIENTATION_HORIZONTAL,
                ORIENTATION_VERTICAL: ORIENTATION_VERTICAL,
                DESIGNER_TYPE_DVS: 8,

                isCrossSells: function(productSlug, availableSubstrates) {
                    if (productSlug != 'bc') {
                        return false;
                    }
                    var crossSells = ['15pt_card_stock', '120_opaque', '100lbs_accent_opaque'];

                    return _.any(availableSubstrates, function(substrate) {
                        return $.inArray(substrate, crossSells);
                    });
                }
            }
        );
    }
);
